<template>
  <NuxtImg
    :src="image?.filename ?? ''"
    :alt="image?.alt ?? ''"
    :format="extension == 'svg' ? 'svg' : 'webp'"
    provider="storyblok"
    :quality="extension == 'svg' ? 100 : 80"
    :loading="fetchPriority == 'high' ? 'eager' : 'lazy'"
    :fetchPriority="fetchPriority"
    v-bind="{
      width,
      height,
      placeholder,
    }"
  />
</template>

<script lang="ts" setup>
import { AssetStoryblok } from "~/types/bloks";

const props = withDefaults(
  defineProps<{
    image?:
      | {
          filename: string;
          alt: string;
        }
      | AssetStoryblok;
    optimize?: boolean;
    width?: string;
    height?: string;
    placeholder?: boolean;
    fetchPriority?: "high" | "low" | "auto";
  }>(),
  {
    fetchPriority: "auto",
  }
);

const extension = props.image?.filename?.match(/[^.]+$/g)?.[0];
</script>
